module.exports = __webpack_public_path__ + "static/img/weixin.15bb146.png";


//////////////////
// WEBPACK FOOTER
// ./static/weixin.png
// module id = 331u
// module chunks = 1